// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#\\@vmos-vmos-flyout-app__P7RsI button{cursor:pointer}.\\@vmos-vmos-flyout-flyout-wrapper__YJYkl{padding:var(--wb-spacing-s) var(--wb-spacing-s) var(--wb-spacing-s) var(--wb-spacing-s)}.\\@vmos-vmos-flyout-flyout-wrapper___spinner__3Ihnv{height:32px;width:32px}@media(min-width:1280px){.\\@vmos-vmos-flyout-flyout-wrapper__YJYkl{padding:0}}", ""]);
// Exports
exports.locals = {
	"app": "@vmos-vmos-flyout-app__P7RsI",
	"flyoutWrapper": "@vmos-vmos-flyout-flyout-wrapper__YJYkl",
	"flyoutWrapperSpinner": "@vmos-vmos-flyout-flyout-wrapper___spinner__3Ihnv"
};
module.exports = exports;
